// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// SSR/SSG-safe storage: in Node (vite-react-ssg pre-render) localStorage doesn't
// exist. Provide a no-op storage shim so createClient never throws at build time
// and never tries to persist a session in a non-browser environment.
const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const noopStorage = {
  getItem: (_key: string) => null,
  setItem: (_key: string, _value: string) => {},
  removeItem: (_key: string) => {},
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: isBrowser ? window.localStorage : (noopStorage as unknown as Storage),
    persistSession: isBrowser,
    autoRefreshToken: isBrowser,
  }
});
